import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Modal,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useNotify } from 'react-admin';
import { allocateUserSelfApplyAction, fetchProvidersRequest } from './actions';

const TOP = 43;
const LEFT = 46;

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '1px #000',
    padding: theme.spacing(2, 4, 3),
    top: `${TOP}%`,
    left: `${LEFT}%`,
    transform: `translate(-${TOP}%, -${LEFT}%)`,
  },
  progress: {
    marginLeft: theme.spacing(1),
  },
  actionsRow: {
    marginTop: theme.spacing(2),
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const UserSelfApplyAllocateModal: React.FC<Props> = ({ open, onClose, onSuccess }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const notify = useNotify();
  const providers = useSelector((state: any) => state?.userSelfApply?.providers?.data || []);
  const [dateFrom, setDateFrom] = useState<string>('');
  const [dateTo, setDateTo] = useState<string>('');
  const [appliedCount, setAppliedCount] = useState<number | ''>('');
  const [providerId, setProviderId] = useState<number | ''>('');

  useEffect(() => {
    dispatch(fetchProvidersRequest());
  }, [dispatch]);

  const handleSubmit = () => {
    if (!dateFrom || !dateTo || !providerId || !appliedCount) {
      notify('Fill all fields', 'warning');
      return;
    }
    dispatch(allocateUserSelfApplyAction({ 
      dateFrom, dateTo, providerId: Number(providerId), appliedCount: Number(appliedCount) 
    }));
    onSuccess();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <div className={classes.paper}>
        <h2>Allocate user self applies</h2>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Date from"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Date to"
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              label="Applied count"
              type="number"
              value={appliedCount}
              onChange={(e) => setAppliedCount(e.target.value ? Number(e.target.value) : '')}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextField
              fullWidth
              select
              label="Provider"
              value={providerId}
              onChange={(e) => setProviderId(Number(e.target.value))}
            >
              {providers.map((p: { id: number; name: string }) => (
                <MenuItem
                  key={p.id}
                  value={p.id}
                >
                  {p.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.actionsRow}
          justifyContent="flex-end"
        >
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            Create
          </Button>
        </Grid>
      </div>
    </Modal>
  );
};


